export default __webpack_public_path__ + "static/media/sliderMobile_5.0482c932.jpg";